<template>
  <div class="dynamic-by-source-and-gsm">
    <ul class="dynamic-by-source-and-gsm__header">
      <li class="dynamic-by-source-and-gsm__title">
        {{chartTitle}}
      </li>
      <li class="dynamic-by-source-and-gsm__tools" v-if="!dataEmpty">
        <el-button type="text" class="dynamic-by-source-and-gsm__tools-button" :disabled="saveChart" @click="onSave">
          <i class="material-icons color_grey">save</i>
        </el-button>
        <el-button type="text" class="dynamic-by-source-and-gsm__tools-button" v-if="!isEdit" @click="editChart">
          <i class="material-icons color_grey">edit</i>
        </el-button>
      </li>
    </ul>
    <el-card shadow="hover" class="dynamic-by-source-and-gsm__card" v-loading="pending">
      <dynamic-by-source-and-gsm-header :chart-name="name"/>
      <template v-if="!dataEmpty">
        <dynamic-by-source-and-gsm-body
          :data="data"
          :chart-name="name"
          :save-chart="saveChart"
          :title="chartTitle"
          @onSavedChart="handleSaved"
          @onSaveChart="handleSave"
        />
      </template>

      <template v-else>
        {{$t('feed.analytics.sourceAndGsm.noData')}}.
      </template>

    </el-card>
  </div>
</template>

<script>
// config
import { social } from "../../../../../../../config/sourceShortcuts";

// mixins
import { analytics } from "../../../../../../../mixins/analytics";

import {
  TRUST_HOURLY, TRUST_DAILY
} from "../../../../../../../store/actions/analytics";

// components
import DynamicBySourceAndGsmHeader from "./header/DynamicBySourceAndGsmHeader";
import DynamicBySourceAndGsmBody from "./body/DynamicBySourceAndGsmBody";

// vuex
import { mapGetters } from "vuex";

export default {
  name: "DynamicBySourceAndGsm",
  data() {
    return {
      name: "DynamicBySourceAndGsm",
      saveChart: false
    };
  },
  computed: {
    ...mapGetters([
      "socialList",
    ]),
    sourceOf() {
      let sourceOf = [];
      let social  = this.$t('feed.analytics.sourceAndGsm.social');
      if (Object.keys(social.items).some(item => Object.keys(this.data).includes(item) && this.socialList.includes(item))) {
        sourceOf.push(social.name);
      }

      if (Object.keys(this.data).includes(social.excluded.name) && this.socialList.includes(social.excluded.name)) {
        sourceOf.push(social.excluded.title);
      }

      return  sourceOf;
    },
    chartTitle() {
      return  `${this.$t('feed.analytics.sourceAndGsm.title')}: ${this.sourceOf.join(", ")}`;
    },
  },
  methods: {
    isRetro() {
        const retro_max = this.$store.getters.retro_max(this.$route.params.threadId)
        const retrospective = this.$store.getters.retrospective(this.$route.params.threadId)
        let end = new Date(retro_max);
        end.setDate(end.getDate() - 1);
        let condition = retro_max != null && new Date(retro_max) < new Date()
        return condition
        //return [`${condition ? retrospective : this.localPeriod[0].replace(" ", "T")}`, `${condition ? end.toJSON().split('T')[0] : this.localPeriod[1].split(' ')[0]} 23:59:59`.replace(" ", "T")];
    },
  },
  mounted() {
    if (!this.isRetro)
      this.$store.dispatch(TRUST_HOURLY, {chart: this.name, thread: this.$route.params.threadId})
    else
      this.$store.dispatch(TRUST_DAILY, {chart: this.name, thread: this.$route.params.threadId});
  },
  mixins: [
    analytics
  ],
  components: {
    DynamicBySourceAndGsmHeader,
    DynamicBySourceAndGsmBody
  }
};
</script>

<style>
  .dynamic-by-source-and-gsm {
    margin-bottom: 40px;
  }

  .dynamic-by-source-and-gsm__header {
    display: flex;
    justify-content: space-between;
    align-items: start;
    padding: 0;
    margin: 0;
    list-style: none;
  }

  .dynamic-by-source-and-gsm__title {
    margin-bottom: 20px;
    font-family: "Roboto", "Arial", sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 19px;

    color: #5E6D82;
  }

  .dynamic-by-source-and-gsm__tools .material-icons {
    font-size: 16px;
  }

  .dynamic-by-source-and-gsm__tools {
    margin-top: 4px;
    margin-right: 15px;
  }

  .dynamic-by-source-and-gsm__tools-button {
    padding: 0;
    color: #5e6d82;
  }

  .dynamic-by-source-and-gsm__tools-button:hover {
    color: #B3BCCC;
    font-size: 12px;
  }
  @media screen and (max-width: 480px) {
    .dynamic-by-source-and-gsm__card {
      overflow-x: auto;  }
    .dynamic-by-source-and-gsm__tools {
      display: none;
    }
  }
</style>
